
export default {
  props: {
    style: Object,
  },
}
